import type { OrderByFields } from '~/presentation/reports/ui/ReportTable/types';

import { EOrderDirectionType } from '~/presentation/reports/ui/ReportTable/types';

export const syncOrderByWithDimensions = (
  dimensions: string[],
  orderBy: OrderByFields = {},
): OrderByFields => {
  const dimensionSet = new Set(dimensions);

  const orderByDimension = dimensions.reduce<OrderByFields>((acc, key) => {
    acc[key] = orderBy[key] ?? {
      field: key,
      direction: EOrderDirectionType.ASC,
    };
    return acc;
  }, {});

  const orderByMetric = Object.fromEntries(
    Object.entries(orderBy).filter(([key]) => !dimensionSet.has(key)),
  );

  if (dimensions.length < 2 || !Object.keys(orderByMetric).length) {
    return { ...orderByDimension, ...orderByMetric };
  }

  const lastDim = dimensions[dimensions.length - 1];

  return {
    ...Object.fromEntries(dimensions.slice(0, -1).map((k) => [k, orderByDimension[k]])),
    ...orderByMetric,
    [lastDim]: orderByDimension[lastDim],
  };
};
